var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card-actions', {
    attrs: {
      "action-collapse": "",
      "title": "Daftar Konsumen"
    }
  }, [_c('b-row', {
    staticClass: "align-items-end mb-1"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Per halaman",
      "label-for": "perPageSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "5",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Cari",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search",
      "placeholder": "Cari toko / owner / no HP..."
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.applySearch($event);
      }
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v(" Clear ")])], 1)], 1)], 1)], 1), _c('b-col', {
    staticClass: "my-1 d-flex justify-content-md-end",
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_vm.allowCreate() ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Tambah ")], 1) : _vm._e()], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modaldetail",
      "ok-title": "Tutup",
      "ok-variant": "secondary",
      "ok-only": "",
      "centered": "",
      "size": "lg",
      "title": "Detail Konsumen"
    },
    model: {
      value: _vm.showModaldetail,
      callback: function callback($$v) {
        _vm.showModaldetail = $$v;
      },
      expression: "showModaldetail"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("Tanggal")]), _c('p', [_vm._v(_vm._s(_vm.form.tanggal))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("Kondisi")]), _c('p', [_vm._v(_vm._s(_vm.form.kondisi_ket))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("Saldo")]), _c('p', [_vm._v("Rp " + _vm._s(_vm.formatRupiah(_vm.form.saldo)))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("Nama Toko")]), _c('p', [_vm._v(_vm._s(_vm.form.nama_toko))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("Nama Owner")]), _c('p', [_vm._v(_vm._s(_vm.form.nama_owner))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("Bidang Bisnis")]), _c('p', [_vm._v(_vm._s(_vm.form.bisnis_fokus))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("No. HP Konsumen")]), _c('p', [_vm._v(_vm._s(_vm.form.no_hp))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', [_vm._v("Alamat")]), _c('p', [_vm._v(_vm._s(_vm.form.alamat))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Jenis Konsumen")]), _c('p', [_vm._v(_vm._s(_vm.form.type_konsumen ? _vm.form.type_konsumen.nama : "-"))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Bangunan")]), _c('p', [_vm._v(_vm._s(_vm.form.tipe_bangunan))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Kepemilikan Bangunan")]), _c('p', [_vm._v(_vm._s(_vm.form.kepemilikan_bangunan))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Lama Sewa Bangunan")]), _c('p', [_vm._v(_vm._s(_vm.form.lama_sewa))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Keterangan")]), _c('p', [_vm._v(_vm._s(_vm.form.keterangan))])]), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Sales")]), _c('p', [_vm._v(" " + _vm._s(_vm.form.karyawan && _vm.form.karyawan.nama_lengkap ? _vm.form.karyawan.nama_lengkap : "-") + " ")])])], 1)], 1), _vm.allowCreate() || _vm.allowUpdate() ? _c('b-modal', {
    attrs: {
      "id": "modal-konsumen",
      "centered": "",
      "size": "md",
      "title": _vm.id ? 'Form Ubah Konsumen' : 'Form Tambah Konsumen',
      "hide-footer": ""
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('validation-observer', {
    ref: "formajuankonsumen"
  }, [_c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "PackageIcon",
      "size": "19"
    }
  }), _c('h6', {
    staticClass: "ml-50 mb-0"
  }, [_vm._v("Data konsumen")])], 1), !_vm.isSales ? _c('b-alert', {
    staticClass: "py-1 mb-2",
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v(" Konsumen akan disimpan dengan status "), _c('strong', [_vm._v("langsung approved")]), _vm._v(" (bypass alur ajuan konsumen). ")]) : _vm._e(), _c('b-form', [_c('b-row', [!_vm.isSales ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sales",
      "label-for": "v-karyawan_id"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "karyawan_id",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          class: {
            'is-invalid': errors.length > 0
          },
          attrs: {
            "id": "v-karyawan_id",
            "options": _vm.karyawan_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "placeholder": "Pilih sales..."
          },
          model: {
            value: _vm.form.karyawan_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "karyawan_id", $$v);
            },
            expression: "form.karyawan_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 278330168)
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tanggal",
      "label-for": "v-tanggal"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tanggal",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-tanggal",
            "state": errors.length > 0 ? false : null,
            "type": "date",
            "placeholder": "Tanggal"
          },
          model: {
            value: _vm.form.tanggal,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "tanggal", $$v);
            },
            expression: "form.tanggal"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 3857945767)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipe Konsumen",
      "label-for": "v-pelanggan_id"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "pelanggan_id",
      "rules": {
        required: true,
        min: 1
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "v-pelanggan_id",
            "state": errors.length > 0 ? false : null,
            "options": _vm.pelanggan_id,
            "name": "pelanggan_id"
          },
          model: {
            value: _vm.form.pelanggan_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "pelanggan_id", $$v);
            },
            expression: "form.pelanggan_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 411861143)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nama Toko",
      "label-for": "v-nama_toko"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nama_toko",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-nama_toko",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Nama Toko"
          },
          model: {
            value: _vm.form.nama_toko,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "nama_toko", $$v);
            },
            expression: "form.nama_toko"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 479042679)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nama Owner",
      "label-for": "v-nama_owner"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "nama_owner",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-nama_owner",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Nama Owner"
          },
          model: {
            value: _vm.form.nama_owner,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "nama_owner", $$v);
            },
            expression: "form.nama_owner"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1446166185)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Alamat",
      "label-for": "v-alamat"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "alamat",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "v-alamat",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Alamat"
          },
          model: {
            value: _vm.form.alamat,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "alamat", $$v);
            },
            expression: "form.alamat"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 4149721763)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nomor Hp/Telepon",
      "label-for": "v-no_hp"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "no_hp",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-no_hp",
            "state": errors.length > 0 ? false : null,
            "placeholder": "No HP",
            "type": "number"
          },
          model: {
            value: _vm.form.no_hp,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "no_hp", $$v);
            },
            expression: "form.no_hp"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 3052032639)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bisnis Toko",
      "label-for": "v-bisnis_fokus"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "bisnis_fokus",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-bisnis_fokus",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Sembako/Restoran/Lain-lain"
          },
          model: {
            value: _vm.form.bisnis_fokus,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "bisnis_fokus", $$v);
            },
            expression: "form.bisnis_fokus"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2934319416)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipe Bangunan",
      "label-for": "v-tipe_bangunan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "tipe_bangunan",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "v-tipe_bangunan",
            "state": errors.length > 0 ? false : null,
            "options": _vm.tipe_bangunan,
            "name": "tipe_bangunan"
          },
          model: {
            value: _vm.form.tipe_bangunan,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "tipe_bangunan", $$v);
            },
            expression: "form.tipe_bangunan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1491682711)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kepemilikan Bangunan",
      "label-for": "v-kepemilikan_bangunan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "kepemilikan_bangunan",
      "rules": {
        required: true,
        min: 2
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var errors = _ref10.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "v-kepemilikan_bangunan",
            "state": errors.length > 0 ? false : null,
            "options": _vm.kepemilikan_bangunan,
            "name": "kepemilikan_bangunan"
          },
          model: {
            value: _vm.form.kepemilikan_bangunan,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "kepemilikan_bangunan", $$v);
            },
            expression: "form.kepemilikan_bangunan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 392494807)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Lama Sewa",
      "label-for": "v-lama_sewa"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "lama_sewa",
      "rules": {
        required: true,
        min: 1
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref11) {
        var errors = _ref11.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-lama_sewa",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Lama Sewa"
          },
          model: {
            value: _vm.form.lama_sewa,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "lama_sewa", $$v);
            },
            expression: "form.lama_sewa"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 878163306)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Keterangan",
      "label-for": "v-keterangan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "keterangan",
      "rules": "required|min:2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref12) {
        var errors = _ref12.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "v-keterangan",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Keterangan"
          },
          model: {
            value: _vm.form.keterangan,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "keterangan", $$v);
            },
            expression: "form.keterangan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2252977614)
  })], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.showModal = false;
      }
    }
  }, [_vm._v(" Batal ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm.saving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.saving ? "Menyimpan..." : _vm.id ? "Ubah" : "Simpan") + " ")], 1)], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [!_vm.loading && !_vm.items.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada data konsumen "), _vm.filter ? _c('span', [_vm._v(" untuk pencarian “" + _vm._s(_vm.filter) + "”")]) : _vm._e(), _vm._v(". ")]) : _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields,
      "show-empty": "",
      "empty-text": "Tidak ada data"
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + row.index + 1) + " ")])];
      }
    }, {
      key: "cell(konsumen)",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(item.nama_toko || "-") + " ")]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" " + _vm._s(item.nama_owner || "-") + " ")]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" " + _vm._s(item.no_hp || "-") + " ")])];
      }
    }, {
      key: "cell(sales)",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [_vm._v(" " + _vm._s(item.karyawan && item.karyawan.nama_lengkap ? item.karyawan.nama_lengkap : "-") + " ")];
      }
    }, {
      key: "cell(tipe)",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return [_vm._v(" " + _vm._s(item.type_konsumen && item.type_konsumen.nama ? item.type_konsumen.nama : "-") + " ")];
      }
    }, {
      key: "cell(saldo)",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return [_vm._v(" Rp " + _vm._s(_vm.formatRupiah(item.saldo)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(row) {
        return [_vm.allowUpdate() ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Ubah',
            expression: "'Ubah'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-50",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        })], 1) : _vm._e(), _c('b-dropdown', {
          attrs: {
            "size": "sm",
            "variant": "outline-secondary",
            "right": "",
            "no-caret": "",
            "boundary": "viewport"
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "MoreVerticalIcon"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item-button', {
          on: {
            "click": function click($event) {
              return _vm.detail(row.item);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "EyeIcon"
          }
        }), _vm._v(" Detail ")], 1), _vm.allowDelete() ? _c('b-dropdown-item-button', {
          on: {
            "click": function click($event) {
              return _vm.remove(row.item);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _vm._v(" Hapus ")], 1) : _vm._e()], 1)];
      }
    }])
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-between align-items-center mt-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total " + _vm._s(_vm.totalRows) + " data")]), _c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }